function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import AspectRatio from "@churchofjesuschrist/eden-aspect-ratio"; // wraps mask, image, lightrays and icon

const ImageFigure = _ref => {
  let {
    aspectRatio,
    ...props
  } = _ref;
  return aspectRatio ? /*#__PURE__*/React.createElement(AspectRatio, _extends({
    ratio: aspectRatio
  }, props)) : /*#__PURE__*/React.createElement("div", _extends({}, props, {
    style: {
      position: "relative"
    }
  }));
};

ImageFigure.propTypes = {
  /** Contents of ImageFigure - mask, image, lightrays, or icon */
  children: PropTypes.node.isRequired,

  /** Aspect ratio in which you want the image displayed, in the form of n:n (e.g. "1:1", which is square) */
  aspectRatio: PropTypes.oneOf(["1:1", "5:6", "5:8", "6:5", "8:3", "8:5", "16:9"])
};
export default ImageFigure;